<template>
  <div v-if="!commonStore.isHome && !commonStore.isError" class="nav-bar">
    <nav class="w-full fixed z-[100] bg-white border-b border-gray-200">
      <div class="px-6 mx-auto max-full">
        <div class="relative flex items-center justify-between h-20">
          <div class="flex items-center justify-between flex-1">
            <button v-if="commonStore.isAuth" class="w-[54px] overflow-hidden relative" @click="goLanding">
              <img src="@/assets/images/logo.svg" alt="logo" class="w-[52px] h-[52px] rounded-lg" />
            </button>
            <button v-if="commonStore.isAuth"  @click="toggleLanguage" style="margin-left: 10px;">
              <img src="@/assets/images/language.svg" alt="language" style="width: 24px;"/>
            </button>
            <div v-if="isOwnerSigunUp">
              <button v-if="!isOwnerSigunUpAndLogin" class="py-2 px-[22px] text-[14px] leading-[24px] text-[#3F4D5A] font-bold border border-[#F0F2F5] rounded-lg" @click="goLogin">로그인</button>
              <button v-if="isOwnerSigunUpAndLogin" class="py-2 px-[22px] text-[14px] leading-[24px] text-[#3F4D5A] font-bold border border-[#F0F2F5] rounded-lg" @click="logOut">로그아웃</button>
            </div>
            <div v-if="!commonStore.isAuth" class="flex items-center">
              <button class="btn bg-white border-none hover:bg-[#F0F2F5] w-10 min-h-[40px] h-[40px] mr-1 xl:mr-3 buger-menu" :class="{ open: commonStore.openSide }" @click="toggleSide">
                <span></span>
                <span></span>
                <span></span>
              </button>
              <button class="w-[44px] xl:w-[52px] flex items-center justify-center h-[44px] xl:h-[52px] mr-2 xl:mr-3 overflow-hidden relative" @click="goHome">
                <img v-if="logoPath" :src="logoPath" class="w-[44px] xl:w-[52px] h-[44px] rounded-lg object-cover" />
                <img v-else src="@/assets/images/logo.svg" alt="logo" class="w-[44px] xl:w-[52px] h-[44px] rounded-lg" />
              </button>
              <p class="text-lg text-[#3F4D5A] font-bold">{{ academyTitle }}</p>
            </div>
            <div v-if="!commonStore.isAuth" v-click-outside="closeProfile" class="relative xl:mr-5">
              <div class="flex items-center">
                <button
                  v-if="isSuperAdmin"
                  class="mr-10 flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-colors duration-200"
                  @click="handleSwitchGroupSpace"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H16M16 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V16M8 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  그룹 스페이스 전환
                </button>
                <button
                  id="user-menu-button"
                  type="button"
                  class="w-[44px] h-[44px] flex items-center justify-center text-sm rounded-full overflow-hidden border border-[#F0F2F5]"
                  aria-expanded="false"
                  aria-haspopup="true"
                  @click="toggleProfile"
                >
                  <span class="sr-only">Open user menu</span>
                  <div>
                    <img v-if="imgPath" class="w-[44px] h-[44px] object-cover" :src="imgPath" />
                    <img v-else class="w-[44px] h-[44px] object-cover" src="@/assets/images/default_profile.svg" alt="profile" />
                  </div>
                </button>
                <button @click="toggleLanguage" style="margin-left: 10px;">
                  <img src="@/assets/images/language.svg" alt="language" style="width: 24px;"/>
                </button>
              </div>
              <div v-if="isOpenProfile" class="w-[320px] px-3 bg-white rounded-xl absolute top-[63px] right-0 shadow-lg flex flex-col custom-profile-popup">
                <div class="flex gap-2 my-7">
                  <button class="w-[44px] h-[44px] flex items-center justify-center rounded-full overflow-hidden border border-[#F0F2F5]">
                    <img v-if="imgPath" class="w-[44px] h-[44px] object-cover" :src="imgPath" />
                    <img v-else class="w-[44px] h-[44px] object-cover" src="@/assets/images/default_profile.svg" alt="profile" />
                  </button>
                  <div class="flex flex-col">
                    <p class="text-base text-[#333333] font-bold">{{ commonStore.myInfo && commonStore.myInfo.name }}</p>
                    <p class="text-sm text-[#788DA1]">{{ commonStore.myInfo && commonStore.myInfo.email }}</p>
                  </div>
                </div>
                <span class="h-px bg-[#F0F2F5] w-full mb-2"></span>
                <ul>
                  <li class="px-2 hover:bg-[#F0F2F5] rounded-lg cursor-pointer" @click="goSetting">
                    <span class="text-sm text-[#3F4D5A] w-full flex items-center justify-between h-[44px]">
                      {{$t('setting.profile.title1')}}<img class="w-4" src="@/assets/images/icon/ico_arrowLineRight_gray.svg" />
                    </span>
                  </li>
                  <li class="px-2 hover:bg-[#F0F2F5] rounded-lg mb-2 cursor-pointer" @click="logOut">
                    <span class="flex items-center text-sm text-[#3F4D5A] h-[44px]">{{$t('message.common.auth.signout')}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <ul
      v-if="!commonStore.isHome && !commonStore.isAuth"
      id="sidenav"
      class="xl:block w-full xl:w-[270px] h-screen menu-compact bg-base-100 mt-20 fixed z-50 transition-all duration-500 ease-in-out overflow-scroll border border-[#E1E6EA] box-border scroll-hidden"
      :class="{ '-left-full xl:-left-[270px]': isOpen, 'left-0': !isOpen, menu: !isIOSWebview, 'ios-menu': isIOSWebview }"
    >
      <perfect-scrollbar>
        <li v-if="commonStore.sessionInfo && commonStore.sessionInfo.role === 'SUPER_ADMIN'">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold pointer-events-none">시스템 관리자</p>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'admin' }"
            @click="handleLink($event, '/admin')"
          >
            {{ $t('common.menu.admin-console') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5] hidden"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'admin-subscribe' }"
            @click="handleLink($event, '/admin/subscribe')"
          >
            {{ $t('common.menu.admin-subscription') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'admin-migration' }"
            @click="handleLink($event, '/admin/migration')"
          >
            {{ $t('common.menu.admin-migration') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'admin-student' }"
            @click="handleLink($event, '/admin/student')"
          >
            {{ $t('common.menu.admin-student') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'admin-active' }"
            @click="handleLink($event, '/admin/active')"
          >
            {{ $t('common.menu.admin-student-history') }}
          </button>
        </li>
        <li v-if="(permissions.includes('VIEW_DASHBOARD') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 py-3 px-8 text-base text-[#2A333C] font-bold pointer-events-none" :class="{'border-t': isSuperAdmin }">{{ $t('common.home') }}</p>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'dashboard' }"
            @click="handleLink($event, '/dashboard')"
          >
            {{ $t('dashboard.title') }}
          </button>
        </li>
        <li v-if="commonStore.sessionInfo && (permissions.includes('VIEW_STUDENT') || permissions.includes('VIEW_MANAGER') || permissions.includes('MANAGE_SUPERVISE_GROUP') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.manageAccount') }}</p>
          <button
            v-if="permissions.includes('VIEW_STUDENT') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'student' || commonStore.selectedMenu === 'student-add' }"
            @click="handleLink($event, '/student')"
          >
            {{ $t('common.menu.student') }}
          </button>
          <button
            v-if="permissions.includes('VIEW_MANAGER') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'manager' || commonStore.selectedMenu === 'manager-add' }"
            @click="handleLink($event, '/manager')"
          >
            {{ $t('common.menu.manager') }}
          </button>
          <button
            v-if="permissions.includes('MANAGE_SUPERVISE_GROUP') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'group' }"
            @click="handleLink($event, '/group')"
          >
            {{ $t('common.menu.groupSetting') }}
          </button>
        </li>
        <li v-if="commonStore.sessionInfo && (permissions.includes('VIEW_STUDY')) || isOwner || isSuperAdmin">
          <p class="menu-title  mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.manageStudyRoom') }}</p>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'room-status' }"
            @click="handleLink($event, '/room/status')"
          >
            {{ $t('common.menu.roomCreationStatus') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'room-history' }"
            @click="handleLink($event, '/room/history')"
          >
            {{ $t('common.menu.roomCreationHistory') }}
          </button>
        </li>
        <li v-if="commonStore.sessionInfo && (permissions.includes('VIEW_ROOM_USER') || permissions.includes('VIEW_STUDY_TIME') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.manageStudy') }}</p>
          <button
            v-if="permissions.includes('VIEW_ROOM_USER') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'study-status' }"
            @click="handleLink($event, '/study/status')"
          >
            {{ $t('common.menu.currentStudyRecord') }}
          </button>
          <button
            v-if="permissions.includes('VIEW_STUDY_TIME') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'study-history-today' }"
            @click="handleLink($event, '/study/history/today')"
          >
            {{ $t('common.menu.todayStudyRecord') }}
          </button>
          <button
            v-if="permissions.includes('VIEW_STUDY_TIME') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'study-history' }"
            @click="handleLink($event, '/study/history')"
          >
            {{ $t('common.menu.cumulativeStudyRecord') }}
          </button>
        </li>
        <li v-if="commonStore.sessionInfo && (permissions.includes('VIEW_ATTENDANCE_STATUS') || permissions.includes('VIEW_ATTENDANCE_HISTORY') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.attendance') }}</p>
          <button
            v-if="permissions.includes('VIEW_ATTENDANCE_STATUS') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'attendance-status' }"
            @click="handleLink($event, '/attendance/status')"
          >
            {{ $t('common.menu.attendanceStatus') }}
          </button>
          <button
            v-if="permissions.includes('VIEW_ATTENDANCE_HISTORY') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'attendance-history' }"
            @click="handleLink($event, '/attendance/history')"
          >
            {{ $t('common.menu.attendanceRecord') }}
          </button>
        </li>
        <li v-if="(permissions.includes('VIEW_STATISTICS') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.statistics') }}</p>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'stats-study' }"
            @click="handleLink($event, '/stats/study')"
          >
            {{ $t('common.menu.statistics-study') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'stats-connect' }"
            @click="handleLink($event, '/stats/connect')"
          >
            {{ $t('common.menu.statistics-online') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'stats-student' }"
            @click="handleLink($event, '/stats/student')"
          >
            {{ $t('common.menu.statistics-student') }}
          </button>
          <button
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'stats-manager' }"
            @click="handleLink($event, '/stats/manager')"
          >
            {{ $t('common.menu.statistics-manager') }}
          </button>
        </li>
        <!-- TODO : 결제 임시 숨김처리. 추후에 다시 추가 예정. -->
        <!-- <li v-if="!isSuperAdmin">
            <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">결제 관리</p>
            <button
              class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
              :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'subscribe' || commonStore.selectedMenu === 'subscribe-plan' || commonStore.selectedMenu === 'subscribe-unsubscribe' }"
              @click="handleLink($event, '/subscribe')"
            >
              구독 관리
            </button>
            <button
              class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
              :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'payment-payhistory' }"
              @click="handleLink($event, '/payment/payhistory')"
            >
              결제 이력
            </button>
          </li> -->
        <li v-if="(permissions.includes('MANAGE_GROUP') || permissions.includes('MANAGE_GROUP_SETTING') || isOwner || isSuperAdmin) && ['selfstudy', 'grm-oligo-test'].includes(getGroupId)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">알림</p>
          <button
            v-if="permissions.includes('MANAGE_GROUP') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'setting' }"
            @click="handleLink($event, '/notification/template')"
          >
            {{ $t('common.menu.notification-template') }}
          </button>
          <button
            v-if="permissions.includes('MANAGE_GROUP') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'setting' }"
            @click="handleLink($event, '/notification')"
          >
            {{ $t('common.menu.notification-manager') }}
          </button>
        </li>
        <li v-if="(permissions.includes('MANAGE_GROUP') || permissions.includes('MANAGE_GROUP_SETTING') || isOwner || isSuperAdmin)">
          <p class="menu-title mt-3 pt-8 pb-3 px-8 text-base text-[#2A333C] font-bold border-t pointer-events-none">{{ $t('common.menu.settings') }}</p>
          <button
            v-if="permissions.includes('MANAGE_GROUP') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'setting' }"
            @click="handleLink($event, '/setting')"
          >
            {{ $t('common.menu.setAcademyInfo') }}
          </button>
          <button
            v-if="permissions.includes('MANAGE_GROUP_SETTING') || isOwner || isSuperAdmin"
            class="flex items-center py-3 px-8 overflow-hidden text-ellipsis whitespace-nowrap rounded-none transition duration-300 ease-in-out text-base text-[#546778] rounded-box focus:bg-transparent hover:bg-[#F0F2F5]"
            :class="{ 'text-[#1F90FF] font-bold': commonStore.selectedMenu === 'setting-group' }"
            @click="handleLink($event, '/setting/group')"
          >
            {{ $t('common.menu.groupFeatureSettings') }}
          </button>
        </li>
        <div class="mb-[150px]"></div>
      </perfect-scrollbar>
    </ul>

    <GroupSwitchModal
      v-if="showGroupModal"
      @close="closeGroupModal"
      @select-group="onGroupSelect"
    />
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import { useAuthStore, useCommonStore } from '@/store';
import GroupSwitchModal from '@/components/group/GroupSwitchModal.vue';
import { useAdminStore } from '@/store/admin.store';

const elements = [
  {
    name: 'Button',
    path: 'uielements-button',
  },
  {
    name: 'Card',
    path: 'uielements-card',
  },
  {
    name: 'Modal',
    path: 'uielements-modal',
  },
  {
    name: 'Checkbox',
    path: 'uielements-checkbox',
  },
  {
    name: 'TextInput',
    path: 'uielements-textinput',
  },
  {
    name: 'Select',
    path: 'uielements-select',
  },
];

export default {
  name: 'NavBar',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: { GroupSwitchModal },
  props: {
    me: {
      type: Object,
      default() {
        return {
          accountNonLocked: true,
          authenticatedAt: null,
          customerId: '',
          email: '',
          groupId: '',
          name: '',
          phone: null,
        };
      },
    },
  },
  data() {
    return {
      commonStore: useCommonStore(),
      authStore: useAuthStore(),
      adminStore: useAdminStore(),
      isOpenProfile: false,
      selectedMenu: 'dashboard',
      elements: elements,
      isProd: false,
      isLocal: false,
      toggleMenuTimer: null,
      menuOpen: false,
      showGroupModal: false,
    };
  },
  computed: {
    imgPath() {
      return this.commonStore.sessionInfo?.profileImageUrl;
    },
    logoPath() {
      return this.commonStore.academiesInfo?.coverImageUrl;
    },
    academyTitle() {
      return this.commonStore.academiesInfo?.title;
    },
    permissions() {
      return this.commonStore.sessionInfo?.permissions || [];
    },
    role() {
      return this.commonStore.sessionInfo?.role;
    },
    isOwner() {
      return this.commonStore.sessionInfo?.role === 'OWNER';
    },
    isSuperAdmin() {
      return this.commonStore.sessionInfo?.role === 'SUPER_ADMIN';
    },
    isOwnerSigunUp() {
      return this.$route.path.indexOf('auth/signup') !== -1;
    },
    isOwnerSigunUpAndLogin() {
      return this.isOwnerSigunUp && this.commonStore.sessionInfo;
    },
    isOpen() {
      return !this.commonStore.openSide || this.commonStore.isAuth || this.commonStore.isHome || this.commonStore.isError;
    },
    isIOSWebview() {
      return /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
    },
    getGroupId(){
      return this.commonStore.sessionInfo?.groupId;
    },
  },
  mounted() {
    this.init();
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
          //lang값 변경 감지 및 값 교체
          this.commonStore.lang = mutation.target.lang;
        }
      }
    });
    observer.observe(document.documentElement, { attributes: true });
  },
  methods: {
    async init() {
      this.isProd = process.env.ENV === 'prod';
      this.isLocal = process.env.ENV === 'local';
      await this.commonStore.getProfile();
    },
    toggleSide() {
      this.commonStore.openSide = !this.commonStore.openSide;
    },
    toggleProfile() {
      this.isOpenProfile = !this.isOpenProfile;
    },
    closeProfile() {
      this.isOpenProfile = false;
    },
    goLogin() {
      this.authStore.handleLogoutCamStudy()
    },
    goLanding() {
      this.$router.push({ path: `/` });
    },
    goHome() {
      this.$router.push({ path: `/dashboard` });
    },
    goSetting() {
      this.toggleProfile();
      this.$router.push({ path: '/setting/profile' });
    },
    async logOut() {
      this.isOpenProfile = false;
      try {
        await this.authStore.postLogOut();
      } finally {
        this.$sentry.setUser({ id: null });
        this.authStore.handleLogoutCamStudy()
      }
    },
    handleLink(e, path) {
      e.preventDefault();
      if (window.innerWidth < 1024 && this.$router.currentRoute.path === path) {
        this.commonStore.openSide = false;
      } else {
        this.$router.push({ path });
      }
    },
    toggleLanguage () {
      let locale = this.$i18n.locale;
      locale = locale === 'ko' ? 'en' : 'ko';
      localStorage.setItem("grm_locale", locale);
      window.location.reload()
    },
    handleSwitchGroupSpace() {
      this.showGroupModal = true;
    },
    async onGroupSelect(group) {
      const targetGroupId = group?.groupId
      await this.adminStore.switchGroupSpace({ targetGroupId });
      this.showGroupModal = false;
      this.$modal({
        text: '그룹이 변경되었습니다. 대시보드로 이동합니다.',
        onlyOk: true,
        ok: async () => {
          if (this.$route.path === '/dashboard') {
            this.$router.go(0)
          } else {
            await this.commonStore.getSessions()
            await this.commonStore.getAcademies()
            await this.$router.push('/dashboard');
          }
        },
      });

    },
    closeGroupModal() {
      this.showGroupModal = false;
    }
  },
};
</script>

<style scoped lang="scss">
.nav-logo {
  width: 54px;
  height: 32px;
  background: url('../assets/images/logo.svg') no-repeat center / 100% auto;
  display: block;
}
.camstudy-button {
  line-height: 1;
  height: max-content;
  min-height: max-content;
  padding: 0.5rem 1rem;
}
.camstudy-button-wrapper:before {
  content: '';
  display: block;
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.5);
}
.custom-profile-popup {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.08);
}
.scroll-hidden {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-hidden::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.buger-menu {
  position: relative;
  span {
    width: 16px;
    height: 2px;
    background-color: $G-06;
    border-radius: 4px;
    position: absolute;
    left: 12px;
    transition: 0.4s;
    &:nth-of-type(1) {
      top: 14px;
    }
    &:nth-of-type(2) {
      top: 20px;
    }
    &:nth-of-type(3) {
      top: 26px;
    }
  }
  &.open {
    span {
      background-color: $G-06;
      &:nth-of-type(1) {
        transform: translateY(6px) rotate(-45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
      }
      &:nth-of-type(3) {
        transform: translateY(-6px) rotate(45deg);
      }
    }
  }
}
.ios-menu button {
  width: 100%;
}
</style>
